import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires a GA4 page_view on every client-side route change.
 * The initial page_view is sent by the default gtag('config', ...) snippet
 * in public/index.html, so we skip the first mount to avoid duplicates.
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title
    });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
